import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Modal, Icon } from 'antd'
import React from 'react'
import { saveIntake } from './utilities'

// Blocks navigation when `when` is true (i.e. state.dirty === true).
// Returns false from history.block to suppress the native window.confirm
// and let the Ant Design modal own the UX (history v4 behaviour).
export function useNavigationBlocker(when) {
  const history = useHistory()

  useEffect(() => {
    if (!when) return

    const unblock = history.block((location, action) => {
      const proceed = () => {
        unblock()
        // history.replace accepts a Location object and is not wrapped by the
        // org-prefix override in src/history.js (only push is overridden).
        history.replace(location)
      }

      let modal
      modal = Modal.confirm({
        title: (
          <React.Fragment>
            You have unsaved changes
            <Icon
              type="close"
              onClick={() => modal && modal.destroy()}
              style={{ position: 'absolute', top: 16, right: 16, cursor: 'pointer', color: 'rgba(0,0,0,0.45)', fontSize: 14 }}
            />
          </React.Fragment>
        ),
        content: 'Save your progress before leaving?',
        okText: 'Save and Leave',
        cancelText: 'Leave without saving',
        onOk: async () => {
          try {
            await saveIntake()
            proceed()
          } catch (e) {
            Modal.error({
              title: 'Save failed',
              content: 'Could not save your progress. Please try again.',
            })
          }
        },
        onCancel: proceed,
      })

      return false
    })

    return unblock
  }, [when, history])
}
